<template>
  <div class="nv-account">
    <div class="nv-card nv-card--flush">
      <v-data-table
          :headers="headers"
          :items="UserAccount"
          :loading="loading"
          class="nv-table"
          disable-pagination
          group-by="UUID"
          :server-items-length="paging.TotalCount"
          item-key="ID"
          hide-default-footer
          loader-height="3"
          no-data-text="Kayıt Bulunamadı"
          no-results-text="Kayıt Bulunamadı"
          loading-text="Kayıtlar Getiriliyor...">
        <template v-slot:top>
          <div class="nv-table__toolbar">
            <div class="nv-table__heading">
              <h4 class="nv-card__title">Aktivasyon İşlemleri</h4>
              <p class="nv-card__subtitle">Başvurularınızın durumunu takip edebilir, bekleyen işlemleri tamamlayabilirsiniz.</p>
            </div>
            <div class="nv-table__actions">
              <v-btn-toggle
                  v-model="paging.IsActivation"
                  class="nv-segment"
                  mandatory
                  dense
                  @change="GetUserAccount">
                <v-btn :value="true" small>
                  <v-icon x-small left>mdi-check-circle-outline</v-icon>
                  Aktivasyon
                </v-btn>
                <v-btn :value="false" small>
                  <v-icon x-small left>mdi-close-circle-outline</v-icon>
                  DeAktivasyon
                </v-btn>
              </v-btn-toggle>
              <v-btn small outlined color="primary" class="nv-btn" @click="UpdateInfo">
                <v-icon small left>mdi-refresh</v-icon>
                Yenile
              </v-btn>
              <v-btn small depressed color="secondary" class="nv-btn" @click="newBranch">
                <v-icon small left>mdi-source-fork</v-icon>
                Yeni Şube Oluştur
              </v-btn>
              <v-btn small text color="primary" class="nv-btn" @click="Login">
                <v-icon small left>mdi-swap-horizontal</v-icon>
                Giriş Ekranı
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:item="{ item}">
          <tr v-for="(content,index) in paging.IsActivation ? item.ProcessUserAccount : item.CancelUserAccount"
              :key="item.UUID + index">
            <td class="text-center">{{ item.TaxNumber }}</td>
            <td class="text-center">{{ content.UserRole != 'None' ? content.UserRole : '' }}</td>
            <td class="text-center">{{ new Date(item.CreatedDate).toLocaleString('tr') }}</td>
            <td class="text-center">
              <span class="nv-tag">{{ content.UserOption }}</span>
            </td>
            <td class="text-center">{{ content.Alias }}</td>
            <td></td>
          </tr>
        </template>
        <template v-slot:group.header="{group, items, isOpen, toggle}">
          <th colspan="12" class="nv-group">
            <div class="nv-group__row">
              <!-- Sol: etiketler (önceki görünüm) -->
              <div class="nv-group__tags">
                <v-btn icon small @click="toggle" :ref="group" :data-open="isOpen" class="nv-group__toggle"
                       :aria-label="isOpen ? 'Daralt' : 'Genişlet'">
                  <v-icon>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
                <span class="nv-tag nv-tag--solid"
                      :class="headCompany && headCompany.ID == items[0].CompanyID ? 'nv-tag--navy' : 'nv-tag--sky'">
                  {{ items[0].CompanyID }}
                </span>
                <v-tooltip bottom max-width="420">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="nv-tag nv-tag--strong nv-tag--name">
                      <span class="nv-tag__text">{{ items[0].Name }}</span>
                      <v-icon v-if="items[0].Name" class="nv-tag__copy"
                              @click="copyText(items[0].Name)" x-small>
                        mdi-content-copy
                      </v-icon>
                    </span>
                  </template>
                  <span class="font-size-sm">{{ items[0].Name }}</span>
                </v-tooltip>
                <span class="nv-tag">
                  {{ modules.find(x => x.key == items[0].ModuleID)?.value }}
                </span>
                <span class="nv-tag">
                  <span class="nv-tag__key">Zarf UUID</span>
                  {{ items[0].UUID ? items[0].UUID : 'Zarf Oluşturulmadı. Onay Bekleniyor.' }}
                  <v-icon v-if="items[0].UUID" class="nv-tag__copy"
                          @click="copyText(items[0].UUID,'UUID')" x-small>
                    mdi-content-copy
                  </v-icon>
                </span>
                <span class="nv-tag">
                  <span class="nv-tag__key">GİB Kodu</span>
                  {{ items[0].GIBCode }}
                </span>
                <v-tooltip
                    :disabled="items[0].Status != 'WaitingForActivationTime' && items[0].Status != 'WaitingForDeActivationTime'"
                    bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="nv-status" :class="'nv-status--' + GetColor(items[0].Status)">
                      <span class="nv-status__dot"></span>
                      {{ GetStatus(items[0].Status) }}
                    </span>
                  </template>
                  <span class="font-size-sm">{{
                      items[0].Status == 'WaitingForActivationTime' ? new Date(items[0].ActivationDate).toLocaleDateString('tr') : new Date(items[0].DeActivationDate).toLocaleDateString('tr')
                    }}</span>
                </v-tooltip>
              </div>

              <!-- Sağ: işlemler -->
              <div class="nv-group__side">
                <!-- İşlemler menüsü (☰): bekleyen işlem yoksa pasif -->
                <v-menu offset-y left content-class="nv-action-menu">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        small
                        class="nv-action-trigger"
                        :class="{'has-action': ['WaitingForActivation', 'WaitingForDeactivation'].includes(items[0].Status)}"
                        :disabled="!['WaitingForActivation', 'WaitingForDeactivation'].includes(items[0].Status)"
                        aria-label="İşlemler">
                      <v-icon small>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="py-1">
                    <v-list-item v-if="items[0].Status == 'WaitingForActivation'" link @click="OpenModal(items)">
                      <v-icon small color="success" class="mr-3">mdi-check-circle-outline</v-icon>
                      <v-list-item-title>Aktivasyonu Tamamla</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="items[0].Status == 'WaitingForDeactivation'" link @click="OpenModal(items)">
                      <v-icon small color="success" class="mr-3">mdi-check-circle-outline</v-icon>
                      <v-list-item-title>DeAktivasyonu Tamamla</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </th>
        </template>
      </v-data-table>
    </div>

    <v-dialog
        v-model="ModalShow"
        persistent
        max-width="760">
      <v-card class="nv-dialog">
        <div class="nv-dialog__header">
          <span class="nv-dialog__icon">
            <v-icon color="secondary">{{ ModalItem.Status == 'WaitingForDeactivation' ? 'mdi-close-circle-outline' : 'mdi-check-decagram' }}</v-icon>
          </span>
          <div>
            <h4 class="nv-dialog__title">{{ ModalItem.ModuleName + " " + GetStatus(ModalItem.Status) }}</h4>
            <p class="nv-dialog__subtitle">Bilgileri kontrol edip işlemin zamanlamasını seçiniz.</p>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon small @click="ModalShow = false" aria-label="Kapat">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="nv-dialog__body">
          <div class="row">
            <div class="col-lg-8">
              <div class="form-group">
                <label class="nv-label">{{ ModalItem.TaxNumber.length === 10 ? 'Ünvan' : 'Ad Soyad' }}</label>
                <input
                    v-model="ModalItem.Name"
                    class="form-control nv-input"
                    disabled
                    type="text"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label class="nv-label">{{
                    ModalItem.TaxNumber.length == 10 ? 'Vergi Kimlik No' : 'T.C. Kimlik No'
                  }}</label>
                <input
                    v-model="ModalItem.TaxNumber"
                    class="form-control nv-input"
                    disabled="true"
                    type="text"
                    value="3000"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="nv-label">Gönderici Birim (GB) Etiket</label>
                <input
                    v-model="ModalItem.GBAlias"
                    class="form-control nv-input"
                    disabled="true"
                    type="text"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="nv-label">Posta Kutusu (PK) Etiket</label>
                <input
                    v-model="ModalItem.PKAlias"
                    class="form-control nv-input"
                    disabled="true"
                    type="text"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="nv-label">Aktivasyon Zamanlaması Seçiniz</label>
              <div class="nv-choice" role="radiogroup" aria-label="Aktivasyon zamanlaması">
                <button
                    v-for="option in ActivationDateOptions"
                    :key="String(option.value)"
                    type="button"
                    role="radio"
                    :aria-checked="IsNowActivate === option.value ? 'true' : 'false'"
                    class="nv-choice__item"
                    :class="{'is-selected': IsNowActivate === option.value}"
                    @click="IsNowActivate = option.value">
                  <span class="nv-choice__icon">
                    <v-icon small>{{ option.value ? 'mdi-flash-outline' : 'mdi-calendar-clock' }}</v-icon>
                  </span>
                  <span class="nv-choice__body">
                    <span class="nv-choice__title">{{ option.text }}</span>
                    <span class="nv-choice__desc">
                      {{ option.value ? 'Onayınızın ardından işlem hemen başlatılır.' : 'İşlem, aşağıda seçeceğiniz tarihte başlatılır.' }}
                    </span>
                  </span>
                  <span class="nv-choice__radio"></span>
                </button>
              </div>
            </div>
            <div v-if="!IsNowActivate" class="col-12">
              <v-menu
                  ref="date"
                  v-model="dateModal"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="ActivationDate"
                      label="Aktivasyon Tarihi Seçiniz"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      hide-details
                      readonly
                      class="nv-field activationDate"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="ModalItem.ActivationDate"
                    locale="tr-TR"
                    no-title
                    color="primary"
                    :min="activationMinDate"
                    @change="parseDate(ModalItem.ActivationDate)"
                    @input="dateModal = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </div>
        </v-card-text>
        <div class="nv-dialog__footer">
          <v-btn text class="nv-btn" @click="ModalShow = false">
            Kapat
          </v-btn>
          <v-btn
              depressed
              color="success"
              class="nv-btn"
              :disabled="AccountLoading"
              :loading="AccountLoading"
              @click="ModalItem.Status == 'WaitingForDeactivation' ? ConfirmModalOpen('DeActive') : ConfirmModalOpen('Active')">
            <v-icon small left>mdi-check-circle-outline</v-icon>
            {{ ModalItem.ModuleName }} Hesabımı {{ ModalItem.Status == 'WaitingForDeactivation' ? 'De' : '' }}Aktif Et
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <Confirm
        ref="confirm"
        v-model="Process"
        @deActive="DeActivateAccount(ModalItem)"
        @active="ActivateAccount(ModalItem)">
    </Confirm>
  </div>
</template>

<script>
import action from "../../../core/services/WebSocket/action";
import activation from "@/core/services/Activation/action"
import {mapGetters} from "vuex";
import Confirm from "../../content/Confirm";

export default {
  name: "UserAccount",
  components: {
    Confirm
  },
  data() {
    return {
      selected: [],
      headers: [
        {text: 'VERGİ NUMARASI', align: 'center', sortable: false},
        {text: 'KULLANICI ROLÜ', value: 'UserRole', align: 'center', sortable: false},
        {text: 'OLUŞTURMA TARİHİ', align: 'center', sortable: false},
        {text: 'KULLANICI SEÇENEĞİ', value: 'UserOption', align: 'center', sortable: false},
        {text: 'ETİKET', value: 'Alias', align: 'center', sortable: false},
        {text: 'İŞLEMLER', value: 'actions', align: 'right', sortable: false}
      ],
      UserAccount: [],
      modules: [
        {key: 1, value: 'E-Fatura'},
        {key: 2, value: 'E-Arşiv Fatura'},
        {key: 3, value: 'E-İrsaliye'},
        {key: 4, value: 'E-Serbest Meslek Makbuzu'},
        {key: 5, value: 'E-Müstahsil Makbuzu'},
        {key: 6, value: 'E-Defter'},
        {key: 12, value: 'E-Adisyon'},
        {key: 14, value: 'E-Sigorta'},
        {key: 16, value: 'E-Gider Pusulası'},
        {key: 17, value: 'E-Döviz'}
      ],
      paging: {
        PageSize: 100,
        Page: 1,
        TotalCount: 0,
        TaxNumber: '',
        IsActivation: true
      },
      Process: null,
      AccountLoading: false,
      StatusQueryInfo: [],
      headCompany: {},
      loading: false,
      ModalShow: false,
      IsNowActivate: false,
      activationMinDate: null,
      dateModal: false,
      ActivationDate: null,
      ModalItem: {
        ModuleName: "",
        CompanyName: "",
        CompanyID: 0,
        EnvelopeID: 0,
        ModuleID: 0,
        TaxNumber: "",
        ConfirmUserID: "",
        Status: 0,
        Alias: "",
        CreatedDate: "",
        ActivatedDate: "",
        ActivationDate: "",
        ConfirmDate: "",
        BranchCode: "",
        IsDirect: true,
        UserRole: 0,
        UserOption: 0,
      },
      ActivationDateOptions: [
        {text: 'Hemen Gerçekleşsin', value: true},
        {text: 'Belirteceğim Tarihte Gerçekleşsin', value: false},
      ]
    }
  },
  methods: {
    toastSuccess(success) {
      this.$bvToast.toast(success, {
        toaster: 'b-toaster-bottom-right',
        title: 'Başarılı',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000,
        bodyClass: "toastSuccess-body",
        headerClass: "toastSuccess-header",
        toastClass: "toastSuccess-container"
      });
    },
    toastError(error) {
      this.$bvToast.toast(error, {
        toaster: 'b-toaster-bottom-right',
        title: 'Hata',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
        bodyClass: "toastError-body",
        headerClass: "toastError-header",
        toastClass: "toastError-container"
      });
    },
    GetStatus(StatusCode) {
      switch (StatusCode) {
        case 'Active':
          return 'Aktif'
        case 'Passive':
          return 'Pasif'
        case 'WaitingForActivation':
          return 'Aktivasyon Bekleniyor'
        case 'WaitingForActivationConfirmation':
          return 'Aktivasyon Onayı Bekleniyor'
        case 'GibError':
          return "Gib'de Hata Aldı"
        case 'WaitingToBeProcessedByGib':
          return 'Gib Tarafından İşlenmesi Bekleniyor'
        case 'WaitingForDeactivation':
          return 'Deaktivasyon Bekleniyor'
        case 'WaitingForDeactivationConfirmation':
          return 'Deaktivasyon Onayı Bekleniyor'
        case 'WaitingForActivationTime':
          return 'Aktivasyon Tarihi Bekleniyor'
        case 'WaitingForDeActivationTime':
          return 'DeAktivasyon Tarihini Bekleniyor'
        case 'WaitingForSignQueue':
          return 'Belge İmzalanmayı Bekliyor'
        case 'WaitingToBeEnveloped':
          return 'Belge Zarflanmayı Bekliyor'
        case 'Completed':
          return 'Tamamlandı'
        default:
          return 'Durum Sorgulanıyor'
      }
    },
    GetColor(StatusCode) {
      switch (StatusCode) {
        case 'Active':
        case 'Completed':
          return 'success'
        case 'Passive':
        case 'GibError':
          return 'danger'
        default:
          return 'info'
      }
    },
    parseDate(val) {
      this.ActivationDate = new Date(val).toLocaleDateString('tr')
    },
    OpenModal(item) {
      let userAccount = item[0]
      this.ModalItem = item[0];
      let newDay = new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleDateString('tr').split('.')
      this.activationMinDate = `${newDay[2]}-${newDay[1]}-${newDay[0]}`
      this.ModalItem.ActivationDate = `${newDay[2]}-${newDay[1]}-${newDay[0]}`
      this.ActivationDate = `${newDay[0]}.${newDay[1]}.${newDay[2]}`
      this.ModalItem.IsDirect = true;
      this.ModalItem.ModuleName = this.modules.find(x => x.key == userAccount.ModuleID).value;
      let AliasInfo = this.paging.IsActivation ? userAccount.ProcessUserAccount : userAccount.CancelUserAccount
      if (!AliasInfo || (AliasInfo && !AliasInfo.length)) {
        this.toastError((this.paging.IsActivation ? "ProcessUserAccount" : "CancelUserAccount") + " Bilgisi Bulunmamaktadır.")
        return
      }
      let GondericiBirim = AliasInfo.find(x => x.UserRole == 'GondericiBirim')
      let PostaKutusu = AliasInfo.find(x => x.UserRole == 'PostaKutusu')
      this.ModalItem.GBAlias = this.UserAccount.find(x => x.UUID == userAccount.UUID && GondericiBirim) != null ? GondericiBirim.Alias : null;
      this.ModalItem.PKAlias = this.UserAccount.find(x => x.UUID == userAccount.UUID && PostaKutusu) != null ? PostaKutusu.Alias : null;
      this.IsNowActivate = true
      this.ModalShow = true;
    },
    ConfirmModalOpen(val) {
      this.Process = val
      let message = null
      if (val == 'DeActive') {
        message = this.ModalItem.ModuleName + ' Hesabının ' + `<strong>DeAktivasyonu</strong>` + ' Tamamlanacaktır. Devam edilsin mi ?'
      } else {
        message = this.ModalItem.ModuleName + ' Hesabının ' + `<strong>Aktivasyonu</strong>` + ' Tamamlanacaktır. Devam edilsin mi ?'
      }
      this.$refs.confirm.ModalOpen(message)
    },
    async ActivateAccount(ModalItem) {
      this.AccountLoading = true
      if (!this.IsNowActivate && !ModalItem.ActivationDate) {
        this.toastError("Aktivasyonun Gerçekleşeceği Tarih Seçilmelidir.")
      } else {
        //Belgenin Base64'ü Getirilir.
        let document = await activation.ProcessEnvelopeBase64({
          TaxNumber: ModalItem.TaxNumber,
          EnvelopeUUID: ModalItem.UUID
        })
        if (document.status == 200) {
          let signModel = {
            Certificate: {
              Index: this.getCertificate.Index,
              CommonName: this.getCertificate.CommonName,
              SerialNumber: this.getCertificate.SerialNumber,
              Oid: this.getCertificate.Oid,
              FriendlyName: this.getCertificate.FriendlyName
            },
            DocumentBase64: document.data
          }
          //Belge İmzalanmak Üzere Gönderilir.
          let documentSign = await action.SerialSign(signModel)
          if (documentSign && documentSign.status == 200) {
            let confirmModel = {
              IsDirect: this.IsNowActivate,
              ActivationDate: this.IsNowActivate ? null : ModalItem.ActivationDate,
              EnvelopeUUID: ModalItem.UUID,
              documentBase64: documentSign.data,
              ModuleID: ModalItem.ModuleID,
              CompanyID: ModalItem.CompanyID,
              TaxNumber: ModalItem.TaxNumber
            }
            //Hesap Aktif Edilmek Üzere Gönderilir.
            let confirm = await activation.ProcessConfirm(confirmModel)
            if (confirm.status == 200) {
              this.toastSuccess(confirm.data)
              this.IsNowActivate ? ModalItem.Status = 'WaitingToBeProcessedByGib' : ModalItem.Status = 'WaitingForActivationTime'
            } else {
              confirm && confirm.data.Errors ? confirm.data.Errors.forEach((error) => {
                this.toastError(error)
              }) : this.toastError(`Hesap Aktif Edilirken Hata.`);
            }
          } else {
            documentSign && documentSign.data.Errors ? documentSign.data.Errors.forEach((error) => {
              this.toastError(error)
            }) : this.toastError(`Belge İmzalanırken Hata.`);
          }
        } else {
          document && document.data.Errors ? document.data.Errors.forEach((error) => {
            this.toastError(error)
          }) : this.toastError(`Belge Getirilirken Hata.`);
        }
      }
      this.AccountLoading = false
      this.ModalShow = false
    },
    async DeActivateAccount(ModalItem) {
      this.AccountLoading = true
      if (!this.IsNowActivate && !ModalItem.ActivationDate) {
        this.toastError("DeAktivasyonun Gerçekleşeceği Tarih Seçilmelidir.")
      } else {
        //Belgenin Base64'ü Getirilir.
        let document = await activation.CancelEnvelopeBase64({
          TaxNumber: ModalItem.TaxNumber,
          EnvelopeUUID: ModalItem.UUID
        })
        if (document.status == 200) {
          let signModel = {
            Certificate: {
              Index: this.getCertificate.Index,
              CommonName: this.getCertificate.CommonName,
              SerialNumber: this.getCertificate.SerialNumber,
              Oid: this.getCertificate.Oid,
              FriendlyName: this.getCertificate.FriendlyName
            },
            DocumentBase64: document.data
          }
          //Belge İmzalanmak Üzere Gönderilir.
          let documentSign = await action.SerialSign(signModel)
          if (documentSign && documentSign.status == 200) {
            let confirmModel = {
              IsDirect: this.IsNowActivate,
              DeActivationDate: this.IsNowActivate ? null : ModalItem.ActivationDate,
              documentBase64: documentSign.data,
              EnvelopeUUID: ModalItem.UUID,
              ModuleID: ModalItem.ModuleID,
              CompanyID: ModalItem.CompanyID,
              TaxNumber: ModalItem.TaxNumber
            }
            //Hesap DeAktif Edilmek Üzere Gönderilir.
            let confirm = await activation.CancelConfirm(confirmModel)
            if (confirm.status == 200) {
              this.toastSuccess(confirm.data)
              this.IsNowActivate ? ModalItem.Status = 'WaitingToBeProcessedByGib' : ModalItem.Status = 'WaitingForActivationTime'
            } else {
              confirm && confirm.data.Errors ? confirm.data.Errors.forEach((error) => {
                this.toastError(error)
              }) : this.toastError(`Hesap DeAktif Edilirken Hata.`);
            }
          } else {
            documentSign && documentSign.data.Errors ? documentSign.data.Errors.forEach((error) => {
              this.toastError(error)
            }) : this.toastError(`Belge İmzalanırken Hata.`);
          }
        } else {
          document && document.data.Errors ? document.data.Errors.forEach((error) => {
            this.toastError(error)
          }) : this.toastError(`Belge Getirilirken Hata.`);
        }
      }
      this.AccountLoading = false
      this.ModalShow = false
    },
    UpdateInfo() {
      this.GetUserAccount()
      this.$emit('UpdateCompanyInfo')
    },
    async GetUserAccount() {
      this.loading = true
      this.paging.TaxNumber = this.getCertificate.SerialNumber
      let response = this.paging.IsActivation ? await activation.ProcessUserAccount(this.paging) : await activation.CancelUserAccount(this.paging)
      this.UserAccount = []
      if (response && response.status == 200) {
        this.UserAccount = response.data.Content
        this.headCompany = this.getAccount.CompanyResponses?.find(x => x.BranchName == 'Merkez')
        this.$nextTick(() => {
          let refs = Object.keys(this.$refs)
          refs.forEach((x) => {
            if (this.$refs[x] && this.$refs[x].$attrs['data-open']) {
              this.$refs[x].$el.click()
            }
          })
        })
        this.paging.TotalCount = response.data.TotalCount;
      } else {
        response && response.data.Errors ? response.data.Errors.forEach((error) => {
          this.toastError(error)
        }) : this.toastError(`Kullanıcı Bilgileri Getirilirken Hata.`);
      }
      this.loading = false
    },
    newBranch() {
      this.$emit('createBranch');
    },
    async Login() {
      this.$router.push("/login", () => {
      });
      this.getAccount.IsExist = false
    },
    copyText(data, val) {
      navigator.clipboard.writeText(data)
      this.toastSuccess(val == 'UUID' ? "Zarf UUID Kopyalandı." : "Firma Adı Kopyalandı.")
    },
  },
  async created() {
    await this.GetUserAccount()
  },
  computed: {
    ...mapGetters(['currentCompany', 'getCertificate', 'getAccount']),
  },
}
</script>

<style>
.activationDate input {
  font-size: 13px;
}
</style>
